const data = [
  { 
    type: 'motor-dom',
    banner: {
      img: '/images/case/qc-banner.jpg',
      content: {
        title: '汽车行业',
        buttonText: '立即咨询',
        buttonType: 'url'
      }
    },
    projectBg: {
      title: '平台是全国最大的汽车B2B供应链电商平台，通过整合汽车产业链中的各方资源，为经销商提供撮合交易、仓储物流、供应链金融等一站式服务。在汽车经销链条中，经销商需要从厂家或进口商处全款提车，经过运输入库后才可向顾客交车回款，垫资周期长金额大。',
      img: '/images/case/qc-pic.jpg'
    },
    solution: {
      title: '协助平台搭建数智化监控体系，通过先进的数采设备以及多维度的数据采集、校验和动态监测，实时掌握资产情况，为供应链融资提供了更加公开、安全、高效的智能交易闭环。',
      img: '/images/case/qc-pic2.jpg'
    },
    cost: {
      title: '明心数智以CMP-产融管理运营平台输出为基础，通过小程序实现工具化的资产全生命周期监控，结合动态监测评估解决方案，提高了平台供应链融资管理效率，为平台客户提供便捷的金融接入方案，为资金方提供资产实时监控预警的风控赋能。',
      img: '/images/case/qc-pic3.jpg'
    },
  },
  { 
    type: 'cross-border',
    banner: {
      img: '/images/case/kj-banner.jpg',
      content: {
        title: '跨境行业',
        buttonText: '立即咨询',
        buttonType: 'url'
      }
    },
    projectBg: {
      title: '平台上拥有数十万家电商客户通过平台采购海外商品，继而通过电商或社交平台渠道销售给C端。该交易场景需要客户提前一两个月采购商品库存在平台的保税仓，资金垫付周期长，亟需供应链资金支持。',
      img: '/images/case/kj-pic.jpg'
    },
    solution: {
      title: '1. 基于平台客户数量巨大、缺乏批量评估手段的痛点，明心数智帮助平台建立系统化的风险识别与信用审核机制，结合客户与平台的交易数据，引入三方数据源，实现对优质客户的识别和授信审批。\n\n2. 引入银行资金对平台交易提供资金支持，实现全线上授信、支用还款和风险预警。',
      img: '/images/case/kj-pic2.jpg'
    },
    cost: {
      title: '方案完善了企业商业模式，建立生态金融壁垒，提升股权及债权融资价值： \n\n1. 明心数智协助平台建立生态金融体系，完善商业模式，助力平台一年时间内新增两轮股权融资，企业估值大幅提升，累计获得股权投资数亿元。\n\n2. 在明心数智产融方案协助下，企业累计获得银行数亿元供应链资金。\n\n3. 企业成为细分行业首家直接对接银行资金的产业互联网平台，打造行业金融标准。',
      img: '/images/case/kj-pic3.jpg'
    },
  },
  { 
    type: 'textile-industry',
    banner: {
      img: '/images/case/fz-banner.jpg',
      content: {
        title: '纺织行业',
        buttonText: '立即咨询',
        buttonType: 'url'
      }
    },
    projectBg: {
      title: '平台内拥有数万家纺织产业链上下游企业，其中包括贸易商和加工厂。在纺织行业交易习惯中，加工厂向贸易商销售需要给到贸易商数个月的账期，而加工厂采购原材料需要先款后货，垫资压力大。针对这类情况通过产业数字化能力获取加工厂的经营数据，助力完善金融机构的风控要求，为加工厂解决融资问题，大大提升平台的赋能能力。',
      img: '/images/case/fz-pic.jpg'
    },
    solution: {
      title: '建立加工厂经营监管体系，通过实时监控加工厂主要生产设备数据与平台业务开展情况，结合多维度数据链校验，创设纺织行业供应链金融解决方案。',
      img: '/images/case/fz-pic2.jpg'
    },
    cost: {
      title: '1、通过物联网、大数据、云计算等技术应用，融合产业多维数据、先进算法及经营评估预测模型，形成纺织加工厂企业画像，将优质客户线上推送至银行，解决客户融资需求。\n\n2、明心助力核心平台提升产业供应链竞争力，通过数字化系统能力提升产业与金融结合效率，降低经营成本，沉淀行业生产经营数据，提升平台价值。\n\n3、通过明心智能预警系统对加工厂客户的实时线上监测及智能化经营分析，向银行提供一站式解决方案，实现精准授信和有效的贷中监控预警、贷后管理及风险防控。',
      img: '/images/case/fz-pic3.jpg'
    },
  },
  { 
    type: 'glass-industry',
    banner: {
      img: '/images/case/bl-banner.jpg',
      content: {
        title: '玻璃行业',
        buttonText: '立即咨询',
        buttonType: 'url'
      }
    },
    projectBg: {
      title: '平台内拥有超过三千家中小玻璃加工厂和超过三万家幕墙厂及门窗厂。在玻璃加工交易中，玻璃加工厂需要给下游客户账期，而玻璃加工厂向原片厂采购需要先款后货，玻璃加工厂在生产过程存在资金需求。玻璃加工行业为传统制造业，针对这类情况通过产业数字化能力获取加工厂的经营数据，助力完善金融机构的风控要求，为加工厂解决融资问题。',
      img: '/images/case/bl-pic.jpg'
    },
    solution: {
      title: '建立加工厂经营监管体系，通过实时监控加工厂主要生产设备数据与平台业务开展情况，结合多维度数据链校验，创设玻璃行业供应链金融解决方案。',
      img: '/images/case/bl-pic2.jpg'
    },
    cost: {
      title: '1、通过物联网、大数据、云计算等技术应用，融合产业多维数据、先进算法及经营评估预测模型，形成玻璃加工厂企业画像，将优质客户线上推送至银行，解决客户融资需求。\n\n2、明心助力核心平台提升产业供应链竞争力，通过数字化系统能力提升产业与金融结合效率，降低经营成本，沉淀行业生产经营数据，提升平台价值。\n\n3、通过明心智能预警系统对加工厂客户的实时线上监测及智能化经营分析，向银行提供一站式解决方案，实现精准授信和有效的贷中监控预警、贷后管理及风险防控。',
      img: '/images/case/bl-pic3.jpg'
    },
  },
  { 
    type: 'mro',
    banner: {
      img: '/images/case/mro-banner.jpg',
      content: {
        title: 'MRO行业',
        buttonText: '立即咨询',
        buttonType: 'url'
      }
    },
    projectBg: {
      title: 'MRO的企业在经营过程中，仓储场景是一项必不可少的环节。因该行业SKU种类繁杂，对于仓库管理要求较高，针对这类情况通过系统化管理提升仓库场景监控能力将助力完善金融机构的风险控制维度。',
      img: '/images/case/mro-pic.jpg'
    },
    solution: {
      title: '协助平台建立仓库数字化监管体系，结合多维数据链校验仓库金融方案的合理性，通过三方数据实时监控仓库数据与线下实体仓库变动情况。',
      img: '/images/case/mro-pic2.jpg'
    },
    cost: {
      title: '明心助力合作企业提高仓库场景的货物周转效率和变现能力，提升平台供应链竞争力，相比传统模式，无需质押，通过数字化系统能力提升产业融资效率，降低经营成本。',
      img: '/images/case/mro-pic3.jpg'
    },
  },
  { 
    type: 'retail-e-commerce',
    banner: {
      img: '/images/case/ls-banner.jpg',
      content: {
        title: '零售电商行业',
        buttonText: '立即咨询',
        buttonType: 'url'
      }
    },
    projectBg: {
      title: '平台是集合全球60余家运动品牌的B2B2C平台，帮上游品牌商提升商品销量，帮下游万余家小B解决品牌准入难、备货难的问题。基于交易过程中的采购环节，小B电商从平台采购需要现款，小B在京东、天猫等电商平台需要现货上架、且与C端的结算存在账期，导致小B有融资需求。',
      img: '/images/case/ls-pic.jpg'
    },
    solution: {
      title: '通过明心CMP-产融管理运营平台的输出，解决电商小B批量评估和账期管理需求，并链接各大银行资金，以平台为核心，为小B提供金融赋能。通过产业数字化能力获取小B的经营数据，帮助银行完善风控手段。',
      img: '/images/case/ls-pic2.jpg'
    },
    cost: {
      title: '明心数智以CMP-产融管理运营平台输出为基础，结合动态监测评估算法，提高了平台供应链融资效率和风控能力，巩固了供应链竞争力，夯实了市场龙头地位。',
      img: '/images/case/ls-pic3.jpg'
    },
  },
  { 
    type: 'plastic-packaging',
    banner: {
      img: '/images/case/sl-banner.jpg',
      content: {
        title: '塑料包装行业',
        buttonText: '立即咨询',
        buttonType: 'url'
      }
    },
    projectBg: {
      title: '平台通过塑编上游原材料的供应，结合终端塑编袋的用户需求，整合塑编厂加入平台，形成了稳定的闭环。塑编加工行业有非常强的产业集群效应，工厂存在企业规模小、产能不足 、生产效率低、经营成本大等问题。',
      img: '/images/case/sl-pic.jpg'
    },
    solution: {
      title: '通过前端SaaS后端大数据平台等一整套数字化信用管理产品体系，协助平台对生态链下游企业进行经营分析、交易真实性验证，并提供账期管理服务，其中包括客户动态评分评级、经营监测、经营异常预警和账期管理等。',
      img: '/images/case/sl-pic2.jpg'
    },
    cost: {
      title: '协助平台精准调配订单交予合作工厂进行生产，高效利用闲置产能，并接入供应链金融方案为合作工厂的生产型采购提供资金，通过实时监控工厂生产经营状况为资金方提供动态预警，最终实现场景供应链闭环。',
      img: '/images/case/sl-pic3.jpg'
    },
  },
]

export default data